import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { fileUrl, errMsg } from "@/lib/api";
import { uploadPhoto } from "@/lib/media";

export default function PhotoPicker({ value, onChange, max = 3, kind = "request", label = "Adicionar foto" }) {
  const input = useRef(null);
  const [loading, setLoading] = useState(false);

  const pick = async (e) => {
    const files = [...e.target.files].slice(0, max - value.length);
    e.target.value = "";
    setLoading(true);
    const added = [];
    for (const f of files) {
      if (f.size > 15 * 1024 * 1024) { toast.error("Foto muito grande."); continue; }
      try { added.push(await uploadPhoto(f, kind)); } catch (err) { toast.error(err.response ? errMsg(err) : err.message); }
    }
    setLoading(false);
    onChange([...value, ...added]);
  };

  return (
    <div className="flex flex-wrap gap-3">
      {value.map((p) => (
        <div key={p} className="relative">
          <img src={fileUrl(p)} alt="Foto enviada" className="h-24 w-24 rounded-2xl object-cover" />
          <button type="button" onClick={() => onChange(value.filter((x) => x !== p))} aria-label="Remover foto"
            className="absolute -right-2 -top-2 flex h-9 w-9 items-center justify-center rounded-full bg-slate-800 text-white" data-testid="photo-remove-button">
            <X className="h-5 w-5" />
          </button>
        </div>
      ))}
      {value.length < max && (
        <button type="button" onClick={() => input.current.click()} disabled={loading}
          className="flex h-24 min-w-[96px] flex-col items-center justify-center gap-1 rounded-2xl border-2 border-dashed border-slate-300 px-3 text-sm font-semibold text-slate-600 hover:border-orange-400 hover:text-orange-600"
          data-testid={`photo-add-button-${kind}`}>
          {loading ? <Loader2 className="h-7 w-7 animate-spin" /> : <Camera className="h-7 w-7" />}
          {loading ? "Enviando..." : label}
        </button>
      )}
      <input ref={input} type="file" accept="image/*" multiple={max > 1} hidden onChange={pick} data-testid={`photo-input-${kind}`} />
    </div>
  );
}
